<kl-form-container
  [title]="
    title + (mode === 'view' || mode === 'edit' ? this.entity.username : '')
  "
  [mode]="mode"
  [pageId]="tabId ? tabId : modalId"
  [alertMessage]="alertMessage"
  [alertShow]="alertShow || errorShow"
  [alertType]="alertType"
  (onCloseAlert)="alertShow = false; errorShow = false"
  (onCommitSave)="commitSave($event)"
>
  <form #userForm="ngForm" novalidate>
    <accordion>
      <accordion-group
        [isOpen]="isOpenFirstAccordion"
        (isOpenChange)="isOpenFirstAccordion = $event"
      >
        <div accordion-heading class="clearfix">
          {{ "general_information" | translate }}
          <span class="badge badge-secondary float-right pull-right"
            ><i
              class="fa"
              [ngClass]="isOpenFirstAccordion ? 'fa-minus' : 'fa-plus'"
            ></i
          ></span>
        </div>
        <div class="col-md-12 col-sm-12">
          <div class="row">
            <div class="col-md-6 col-sm-12">
              <div class="form-group row">
                <label for="user_username" class="col-md-4 col-sm-6">
                  <small
                    >{{ "username" | translate }}
                    <i class="text-danger">*</i></small
                  >
                </label>
                <div class="col-md-8 col-sm-6">
                  <input
                    [disabled]="isReadOnly"
                    type="text"
                    #focusElement
                    id="user_username"
                    name="user_username"
                    class="form-control form-control-sm"
                    required
                    maxlength="50"
                    #user_username="ngModel"
                    [ngClass]="
                      errorShow && user_username.invalid ? 'errorInput' : ''
                    "
                    (ngModelChange)="formChange(true)"
                    [(ngModel)]="entity.username"
                  />
                  <div
                    *ngIf="errorShow && user_fullname.invalid"
                    class="errorMessage"
                  >
                    {{ "important_area" | translate }}
                  </div>
                </div>
              </div>
              <div class="form-group row">
                <label for="user_fullname" class="col-md-4 col-sm-6">
                  <small
                    >{{ "fullname" | translate }}
                    <i class="text-danger">*</i></small
                  >
                </label>
                <div class="col-md-8 col-sm-6">
                  <input
                    [disabled]="isReadOnly"
                    type="text"
                    id="user_fullname"
                    name="user_fullname"
                    class="form-control form-control-sm"
                    required
                    maxlength="100"
                    #user_fullname="ngModel"
                    [ngClass]="
                      errorShow && user_fullname.invalid ? 'errorInput' : ''
                    "
                    (ngModelChange)="formChange(true)"
                    [(ngModel)]="entity.full_name"
                  />
                  <div
                    *ngIf="errorShow && user_fullname.invalid"
                    class="errorMessage"
                  >
                    {{ "important_area" | translate }}
                  </div>
                </div>
              </div>
              <div class="form-group row">
                <label for="user_email" class="col-md-4 col-sm-6">
                  <small
                    >{{ "email" | translate }}
                    <i class="text-danger">*</i></small
                  >
                </label>
                <div class="col-md-8 col-sm-6">
                  <input
                    [disabled]="isReadOnly"
                    type="text"
                    maxlength="50"
                    name="user_email"
                    id="user_email"
                    #user_email="ngModel"
                    [(ngModel)]="entity.email"
                    (ngModelChange)="formChange(true)"
                    [ngClass]="
                      errorShow && user_email.invalid ? 'errorInput' : ''
                    "
                    class="form-control form-control-sm"
                    aria-describedby="user_name_help_text"
                    required
                  />
                  <div
                    *ngIf="errorShow && user_email.invalid"
                    class="errorMessage"
                  >
                    {{ "important_area" | translate }}
                  </div>
                </div>
              </div>
            </div>
            <div class="col-md-6 col-sm-12">
              <div class="form-group row">
                <div class="col-md-4 col-sm-6">
                  <label for="user_password_expired">
                    <small
                      >{{ "password_expired" | translate }}
                      <i class="text-danger">*</i></small
                    >
                  </label>
                </div>
                <div class="col-md-8 col-sm-6">
                  <p-calendar
                    id="user_password_expired"
                    [style]="{ width: '100%' }"
                    dateFormat="dd.mm.yy"
                    styleClass="dateInput"
                    [disabled]="isReadOnly"
                    [showIcon]="true"
                    [locale]="locale"
                    [dateFormat]="dateFormatString"
                    #user_password_expired="ngModel"
                    name="user_password_expired"
                    [ngClass]="
                      errorShow && user_password_expired.invalid ? 'err' : ''
                    "
                    (ngModelChange)="formChange(true)"
                    [(ngModel)]="entity.password_expired"
                    required
                  >
                  </p-calendar>
                  <a
                    class="calendarInput inputClear"
                    [hidden]="!entity.password_expired || isReadOnly"
                    (click)="entity.password_expired = null"
                  >
                    <i class="fal fa-close"></i>
                  </a>
                  <div
                    *ngIf="errorShow && user_password_expired.invalid"
                    class="errorMessage"
                  >
                    {{ "important_area" | translate }}
                  </div>
                </div>
              </div>
              <div class="form-group row">
                <label for="user_localization" class="col-md-4 col-sm-6">
                  <small>{{ "default_language" | translate }}</small>
                </label>
                <div class="col-md-8 col-sm-6">
                  <p-dropdown
                    [emptyFilterMessage]="'not_found' | translate"
                    [disabled]="isReadOnly"
                    [options]="[
                      { label: 'lang_tr' | translate, value: 'tr_TR' },
                      { label: 'lang_en' | translate, value: 'en_US' },
                      { label: 'lang_az' | translate, value: 'az_AZ' },
                      { label: 'lang_ru' | translate, value: 'ru_RU' }
                    ]"
                    [(ngModel)]="entity.localization"
                    (onChange)="formChange(true)"
                    name="user_localization"
                    id="user_localization"
                    [style]="{ width: '100%' }"
                  >
                  </p-dropdown>
                </div>
              </div>
              <div class="form-group row">
                <label for="current_account" class="col-md-4 col-sm-12">
                  <small>{{ "current_account" | translate }}</small>
                </label>
                <div class="input-group col-md-8 col-sm-12">
                  <input
                    class="form-control form-control-sm"
                    [value]="current_account_description"
                    [disabled]="true"
                    id="current_account"
                    name="current_account"
                  />
                  <a
                    class="inputClear"
                    [hidden]="!entity.curr_account_id || isReadOnly"
                    (click)="clearCurrentAccount()"
                  >
                    <i class="fal fa-close"></i>
                  </a>
                  <div
                    class="input-group-append"
                    (click)="!isReadOnly ? setModal() : ''"
                  >
                    <span
                      class="input-group-text transparent"
                      id="basic-addon342"
                    >
                      <i class="fal fa-ellipsis-h" aria-hidden="true"></i>
                    </span>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </accordion-group>
      <accordion-group
        [isOpen]="isOpenSecondAccordion"
        (isOpenChange)="openRoleAccordion($event)"
      >
        <div accordion-heading class="clearfix">
          {{ "user_roles" | translate }}
          <span class="badge badge-secondary float-right pull-right">
            <i
              class="fa"
              [ngClass]="isOpenSecondAccordion ? 'fa-minus' : 'fa-plus'"
            ></i
          ></span>
        </div>
        <button
          type="button"
          class="btn btn-default mb-1 btn-sm"
          [hidden]="isReadOnly"
          (click)="addNewRoleRow()"
        >
          {{ "add_new_line" | translate }}
        </button>
        <kl-form-entry-grid
          *ngIf="showRoleGrid"
          (onAddNew)="addNewRoleRow($event)"
          (onLostFocus)="changeRoleColumn($event)"
          (onColumnChange)="changeRoleColumn($event)"
          (onDelete)="formChange(true)"
          [actionButton]="isReadOnly"
          [allowResizing]="'Both'"
          [deferResizing]="false"
          [allowDelete]="true"
          [collectionView]="roleCollectionView"
          [selectionColumn]="1"
          [isReadOnly]="isReadOnly"
          [columns]="[
            {
              header: 'role_name' | translate,
              binding: 'role.id',
              dataMap: roleListDataMap,
              showDropDown: true,
              width: '*'
            }
          ]"
        >
        </kl-form-entry-grid>
      </accordion-group>
    </accordion>
  </form>
</kl-form-container>
